<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :title="dialogTitle"
      width="620px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :show-close="true"
      @close="handleClose"
      class="reminder-dialog"
    >
      <div class="reminder-list" v-if="reminders.length > 0">
        <div
          class="reminder-item"
          v-for="(item, index) in reminders"
          :key="item.id || index"
        >
          <div class="reminder-meta">
            <div class="reminder-title">{{ item.reminderTitle }}</div>
            <span class="reminder-time">{{ item.createTime || '' }}</span>
          </div>
          <div class="reminder-content" v-if="item.reminderContent">
            {{ item.reminderContent }}
          </div>
          <div class="reminder-actions">
            <el-button
              size="small"
              @click="handleDismissType(item)"
              :loading="dismissingTypeId === item.id"
            >此类不再提醒</el-button>
            <el-button
              size="small"
              @click="handleDismissOne(item)"
              :loading="dismissingOneId === item.id"
            >不再提醒</el-button>
            <el-button
              size="small"
              type="primary"
              @click="handleGoDetail(item)"
              v-if="item.routePath"
            >查看详情</el-button>
          </div>
        </div>
      </div>

      <div class="reminder-empty" v-else>
        <i class="el-icon-bell" style="font-size:48px;color:#C0C4CC;"></i>
        <p>暂无提醒消息</p>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="visible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { checkReminders, dismissReminder, dismissReminderType } from '@/api/modules/reminder'

export default {
  name: 'HomeReminder',
  data() {
    return {
      visible: false,
      reminders: [],
      dismissingOneId: null,
      dismissingTypeId: null
    }
  },
  computed: {
    dialogTitle() {
      if (this.reminders.length === 0) return '消息提醒'
      return `消息提醒（共${this.reminders.length}条）`
    }
  },
  methods: {
    // 外部调用：检查并弹框
    async checkAndShow() {
      try {
        const res = await checkReminders()
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.reminders = res.data
          this.visible = true
        }
      } catch (error) {
        console.error('获取提醒消息失败:', error)
      }
    },

    // 不再提醒（单条）
    async handleDismissOne(item) {
      this.dismissingOneId = item.id
      try {
        await dismissReminder(item.id)
        this.reminders = this.reminders.filter(r => r.id !== item.id)
        if (this.reminders.length === 0) {
          this.visible = false
        }
      } catch (error) {
        console.error('消除提醒失败:', error)
      } finally {
        this.dismissingOneId = null
      }
    },

    // 此类不再提醒
    async handleDismissType(item) {
      this.dismissingTypeId = item.id
      try {
        const type = item.reminderType
        await dismissReminderType(type)
        // 移除该类型的所有提醒
        this.reminders = this.reminders.filter(r => r.reminderType !== type)
        if (this.reminders.length === 0) {
          this.visible = false
        }
      } catch (error) {
        console.error('关闭提醒类型失败:', error)
      } finally {
        this.dismissingTypeId = null
      }
    },

    // 查看详情：消除本条提醒后跳转
    async handleGoDetail(item) {
      if (!item.routePath) return
      const routePath = item.routePath
      try {
        await dismissReminder(item.id)
      } catch (e) {
        // 消除失败也继续跳转
      }
      this.reminders = this.reminders.filter(r => r.id !== item.id)
      if (this.reminders.length === 0) {
        this.visible = false
      }
      this.$nextTick(() => {
        if (routePath.startsWith('http://') || routePath.startsWith('https://')) {
          window.open(routePath, '_blank')
        } else {
          this.$router.push(routePath).catch(() => {})
        }
      })
    },

    handleClose() {
      // 用户手动关闭弹框，不做任何操作，只是隐藏
    }
  }
}
</script>

<style lang="less" scoped>
.reminder-dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid #EBEEF5;
    background: #fafafa;

    .el-dialog__title {
      font-size: 16px;
      font-weight: 600;
      color: #333;
    }
  }

  /deep/ .el-dialog__body {
    padding: 20px;
    min-height: 120px;
  }

  /deep/ .el-dialog__footer {
    padding: 15px 20px 20px;
    border-top: 1px solid #EBEEF5;
  }
}

.reminder-list {
  max-height: 420px;
  overflow-y: auto;
}

.reminder-item {
  padding: 16px;
  margin-bottom: 12px;
  background: #fafbfc;
  border: 1px solid #e8eaed;
  border-radius: 8px;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.reminder-meta {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 10px;

  .reminder-time {
    font-size: 12px;
    color: #999;
    white-space: nowrap;
    margin-left: 12px;
  }
}

.reminder-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  line-height: 1.5;
  flex: 1;
}

.reminder-content {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  white-space: pre-wrap;
  word-break: break-all;
  padding: 10px 12px;
  background: #fff;
  border-radius: 4px;
  margin-bottom: 12px;
}

.reminder-actions {
  text-align: right;

  .el-button + .el-button {
    margin-left: 8px;
  }
}

.reminder-empty {
  text-align: center;
  padding: 30px 20px;
  color: #999;

  p {
    font-size: 14px;
    margin-top: 12px;
  }
}

.dialog-footer {
  text-align: right;

  .el-button + .el-button {
    margin-left: 10px;
  }
}
</style>
